// extracted by mini-css-extract-plugin
module.exports = {"card":"_1fBBT","shimmerImg":"_729X3","shimmer":"_2aFyd"};